































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import jsZip from "jszip";
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import AnswerImageArea from "../../components/AnswerImageArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import QuestionnaireAnswerArea from "../../components/QuestionnaireAnswerArea.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import { BModal } from 'bootstrap-vue';
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import { BaseSheetField, PageItem, DirectionEnum, AnswerText, ParamBaseSheetField, CurrentModeEnum, AnswerImage, AnswerImageDiscription, QuestionImageDiscription } from "../../modules/student/DigitalReport"
import { BaseSheetItem, Lesson, LessonClass, TabNoEnum } from "../../modules/student/LessonClass"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import { QuestionnaireGroup } from "../../modules/Questionnaire"
import heic2any from "heic2any";

const PreviewImageTypeEnum = Common.PreviewImageTypeEnum;

export interface Data {
  // タブ共通の変数
  initiarizedData: boolean
  fieldMargin: number
  mainAreaWidth: number
  mainAreaHeight: number
  isShortcutKeyEnable: boolean
  pcHelpFields: any[]
  tabletHelpFields: any[]
  keyCode: string
  tabNo: number
  TabNoEnum: Readonly<{KyouzaiAnswer: number; KyouzaiExplanation: number; TestAnswer: number; TestCorrect: number; Questionnaire: number}>
  errors: string[]
  // データ
  lesson: Lesson
  lessonClass: LessonClass
  testItem: BaseSheetItem
  kyouzaiItem: BaseSheetItem
  // 解答モード・解答ツールボックス系
  drawMode: number
  drawColor: string
  thickness: number
  kaitouToolboxLeft: number
  kaitouToolboxTop: number
  scoringToolboxLeft: number
  scoringToolboxTop: number
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  // テキスト編集ボックス系
  fontSize: number
  lineHeight: number
  textColor: string
  choiceAreaLeft: number
  choiceAreaTop: number
  selectedStamp: any
  // スプリットパン用変数 テストのみ使用
  DirectionEnum: Readonly<{Horizon: number; Vertical: number;}>
  direction: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Scoring: number; Failure: number; Pass: number;}>
  CurrentModeEnum: Readonly<{Answer: number; SelfScoring: number; Preview: number;}>
  isScrolling: boolean
  questionnaire_group: QuestionnaireGroup
  isQuestionnaireTab: boolean
  PreviewImageTypeEnum: Readonly<{None: number; Question: number; Correct: number; Answer: number; Movie: number;}>
  previewImageType: number
  isDispToggre: boolean
  answerImageDiscriptions: AnswerImageDiscription[]
  questionImageDiscriptions: QuestionImageDiscription[]
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "answer-image-area": AnswerImageArea,
    "preview-image-area": PreviewImageArea,
    "questionnaire-answer-area": QuestionnaireAnswerArea,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
    "text-direction-toggle": TextDirectionToggle,
    "text-edit-box": TextEditBox,
  },
  setup(props, context){

// #region [data, コンポーネント参照]

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const kyouzaiAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const kyouzaiExplanationImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const questionnaireModalRef = ref<InstanceType<typeof BModal>>();
    const textEditBoxRef = ref<InstanceType<typeof TextEditBox>>();

    const AnswerTypeEnum = Common.AnswerTypeEnum;
    const StmapTypeEnum = Common.StmapTypeEnum;

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      DirectionEnum: DirectionEnum,
      direction: DirectionEnum.Vertical,
      fieldMargin: 20,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedStamp: null,
      drawMode: Common.DrawModeEnum.None,
      drawColor: "#000000",
      thickness: 2,
      fontSize: 32,
      lineHeight: 0,
      textColor: "#000000",
      choiceAreaLeft: 0,
      choiceAreaTop: 0,
      kaitouToolboxLeft: 0,
      kaitouToolboxTop: 0,
      scoringToolboxLeft: 0,
      scoringToolboxTop: 0,
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      keyCode: null,
      isShortcutKeyEnable: true,
      pcHelpFields: [
        { key: "Tキー + クリック", img: require("@/assets/images/keyboard_T.png"), description: "テキストボックス出力" },
        { key: "テキスト選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "テキストボックス削除" },
        { key: "Dキー + マウス", img: require("@/assets/images/keyboard_D.png"), description: "自由線" },
        { key: "Eキー + マウス", img: require("@/assets/images/keyboard_E.png"), description: "消しゴム" },
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "設問青枠内を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小<br>（手書きモードで設問青枠内では使用できません）" },
      ],
      errors: [],
      tabNo: TabNoEnum.KyouzaiAnswer,
      TabNoEnum: TabNoEnum,
      testItem: null,
      kyouzaiItem: null,
      lesson: null,
      lessonClass: null,
      StudentSheetStatusEnum: Common.StudentSheetStatusEnum,
      CurrentModeEnum: CurrentModeEnum,
      isScrolling: false,
      questionnaire_group: null,
      isQuestionnaireTab: false,
      PreviewImageTypeEnum: PreviewImageTypeEnum,
      previewImageType: PreviewImageTypeEnum.None,
      isDispToggre: false,
      answerImageDiscriptions: [],
      questionImageDiscriptions: [],
    });

    const DrawModeEnum = Common.DrawModeEnum;

// #endregion

// #region [レイアウト整形処理]

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
        state.kaitouToolboxTop = (mainArea.offsetTop + 56);
        state.kaitouToolboxLeft = state.mainAreaWidth - kaitouToolboxWidth.value - 20;
      }
    };

    /************************************************************
     * 各タブの画像を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = (initiarize: boolean = false) => {

      const testQuestionArea = document.getElementById(`question-page-root-${state.direction}-${Common.SheetTypeEnum.LessonTest}`);
      const testAnswerArea = document.getElementById(`answer-page-root-${state.direction}-${Common.SheetTypeEnum.LessonTest}`);
      const testCorrectArea = document.getElementById(`correct-page-root-${state.direction}-${Common.SheetTypeEnum.LessonTest}`);
      const kyouzaiAnswerArea = document.getElementById(`answer-page-root-${state.DirectionEnum.Vertical}-${Common.SheetTypeEnum.LessonKyouzai}`);
      const kyouzaiExplanationArea = document.getElementById(`explanation-page-root-${state.DirectionEnum.Vertical}-${Common.SheetTypeEnum.LessonKyouzai}`);
      const mainArea = document.getElementById("main-area");

      context.root.$nextTick(() => {

        state.tabNo = TabNoEnum.TestAnswer;

        context.root.$nextTick(() => {
          if(testQuestionArea && mainArea){
            const areaW = testQuestionArea.clientWidth - 16;
            const areaH = mainArea.clientHeight - 80;
            
            const scaleW = areaW / state.testItem.base_sheet.questionImageWidth;
            const scaleH = areaH / state.testItem.base_sheet.questionImageHeight;
            const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
            verticalQuestionImageAreaRef.value.inputScale = scale;
            horizonQuestionImageAreaRef.value.inputScale = scale;
          }

          if(testCorrectArea && mainArea){
            const areaW = testCorrectArea.clientWidth - 16;
            const areaH = mainArea.clientHeight - 80;
            
            const scaleW = areaW / state.testItem.base_sheet.width;
            const scaleH = areaH / state.testItem.base_sheet.height;
            const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
            verticalCorrectImageAreaRef.value.inputScale = scale;
            horizonCorrectImageAreaRef.value.inputScale = scale;
          }

          if(testAnswerArea && mainArea){
            const areaW = testAnswerArea.clientWidth - 16;
            const areaH = mainArea.clientHeight - 80;
            
            const scaleW = areaW / state.testItem.pageItems[0].base_width;
            const scaleH = areaH / state.testItem.pageItems[0].base_height;
            const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

            verticalAnswerImageAreaRef.value.inputScale = scale;
            horizonAnswerImageAreaRef.value.inputScale = scale;
          }

          state.tabNo = TabNoEnum.KyouzaiExplanation;

          context.root.$nextTick(() => {

            if(kyouzaiExplanationArea && mainArea){
              const areaW = kyouzaiExplanationArea.clientWidth - 16;
              const areaH = mainArea.clientHeight - 80;
              
              const scaleW = areaW / state.kyouzaiItem.base_sheet.explanationImageWidth;
              const scaleH = areaH / state.kyouzaiItem.base_sheet.explanationImageHeight;
              const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
              kyouzaiExplanationImageAreaRef.value.inputScale = scale;
            }

            state.tabNo = TabNoEnum.KyouzaiAnswer;

            context.root.$nextTick(() => {
              if(kyouzaiAnswerArea && mainArea){
                const areaW = kyouzaiAnswerArea.clientWidth - 16;
                const areaH = mainArea.clientHeight - 80;
                
                const scaleW = areaW / state.kyouzaiItem.pageItems[0].base_width;
                const scaleH = areaH / state.kyouzaiItem.pageItems[0].base_height;
                const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

                kyouzaiAnswerImageAreaRef.value.inputScale = scale;

                if(initiarize && !context.root.$store.state.is_parent){
                  changeSelectedBaseSheetField(0);
                  // state.drawMode = isCanvasDrawable.value ? DrawModeEnum.FreeLine : DrawModeEnum.Text;
                }
              }
            });
          });
        });
      });
    }

// #endregion

// #region [テストタブのスプリッター整形系]

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        state.selectedStamp = null;

        context.root.$nextTick(() => {
          if(state.direction == DirectionEnum.Horizon){
            horizonAnswerImageAreaRef.value.renderCanvas();
          }else{
            verticalAnswerImageAreaRef.value.renderCanvas();
          }
        });
      }
    }

// #endregion

// #region [ページ・タブ切り替え系処理]

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      selectedBaseSheetItem.value.answerPageIdx = idx;
      selectedBaseSheetItem.value.baseSheetFieldIdx = null;
      state.selectedStamp = null;
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      selectedBaseSheetItem.value.questionPageIdx = idx;
    }

    /******************************
     * 解答解説ページ切り替え時のemit
     ******************************/

    const explanationSheetPageChanged = (idx: number) => {
      selectedBaseSheetItem.value.explanationPageIdx = idx;
    }

    /******************************
     * 模範解答ページ切り替え時のemit
     ******************************/

    const correctImagePageChanged = (idx: number) => {
      selectedBaseSheetItem.value.correctPageIdx = idx;
    }

    /******************************
     * タブ切り替え変更監視
     ******************************/

    watch(() => state.tabNo, (newVal) => {
      if(newVal == TabNoEnum.KyouzaiAnswer){
        changeSelectedBaseSheetField(0);
      }else{
        selectedBaseSheetItem.value.baseSheetFieldIdx = null;
      }
      state.selectedStamp = null;
    });

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

    const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

// #endregion

// #region [選択情報]

    /******************************
     * 設問アイコンクリック時のemit
     ******************************/

    const changeSelectedBaseSheetField = async (selectedFieldIdx: number) => {
      selectedBaseSheetItem.value.baseSheetFieldIdx = selectedFieldIdx;
      state.selectedStamp = null;

      if(selectedBaseSheetItem.value.currentMode == CurrentModeEnum.Answer){
        if(selectedBaseSheetField.value){
          if(!isTextDrawable.value && (state.drawMode == DrawModeEnum.Text || state.drawMode == DrawModeEnum.Delete)){
            state.drawMode = DrawModeEnum.None;
          }
          if(!isCanvasDrawable.value && (state.drawMode == DrawModeEnum.FreeLine || state.drawMode == DrawModeEnum.StraightLine || state.drawMode == DrawModeEnum.Marker || state.drawMode == DrawModeEnum.Eraser)){
            state.drawMode = DrawModeEnum.None;
          }

          const baseElemId = `${state.direction}-${selectedBaseSheetItem.value.base_sheet.sheet_type}-${selectedBaseSheetField.value.id}-parent`;
          let toolboxId = "";
          let leftPosName = "";
          let topPosName = "";
          if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Choice){
            toolboxId = "choice-box";
            leftPosName = "choiceAreaLeft";
            topPosName = "choiceAreaTop";
          }else{
            toolboxId = "kaitou-toolbox";
            leftPosName = "kaitouToolboxLeft";
            topPosName = "kaitouToolboxTop";
          }

          autoMoveToolbox(baseElemId, toolboxId, leftPosName, topPosName);
        }
      }else if(selectedBaseSheetItem.value.currentMode == CurrentModeEnum.SelfScoring){
        if(selectedBaseSheetField.value){
          const baseElemId = `scoring-parent-${state.direction}-${selectedBaseSheetItem.value.base_sheet.sheet_type}-${selectedBaseSheetField.value.id}`;
          const toolboxId = "scoring-toolbox";
          autoMoveToolbox(baseElemId, toolboxId, "scoringToolboxLeft", "scoringToolboxTop");
        }
      }      
    }

    /******************************
     * 選択中タブに紐づくBaseSheetItem
     ******************************/

    const selectedBaseSheetItem = computed((): BaseSheetItem => {
      if(state.tabNo == TabNoEnum.KyouzaiAnswer || state.tabNo == TabNoEnum.KyouzaiExplanation){
        return state.kyouzaiItem;
      }else{
        return state.testItem;
      }
    });

    /******************************
     * 現在のページ番号に紐づくPageItem
     ******************************/

    const selectedPageItem = computed((): PageItem => {
      if(!selectedBaseSheetItem.value){
        return null;
      }

      return selectedBaseSheetItem.value.pageItems[selectedBaseSheetItem.value.answerPageIdx];
    });

    /************************************************************
     * 選択中の設問
     ************************************************************/

    const selectedBaseSheetField = computed((): BaseSheetField => {
      return selectedPageItem.value == null || selectedBaseSheetItem.value.baseSheetFieldIdx == null ? null : selectedPageItem.value.base_sheet_fields[selectedBaseSheetItem.value.baseSheetFieldIdx];
    });

// #endregion

// #region [編集可否や解答モード系]

    /************************************************************
     * テキスト解答可否
     ************************************************************/

    const isTextDrawable = computed((): boolean => {
      if(selectedBaseSheetField.value != null){
        return selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Both || selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Text || selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Image;
      }else{
        return true;
      }
    });

    /************************************************************
     * 手書き解答可否
     ************************************************************/

    const isCanvasDrawable = computed((): boolean => {
      if(selectedBaseSheetField.value != null){
        return selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Both || selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Draw || selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Image;
      }else{
        return true;
      }
    });

    /************************************************************
     * 画像解答可否
     ************************************************************/

    const isImageDrawable = computed((): boolean => {
      if(selectedBaseSheetField.value != null){
        return selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Image;
      }else{
        return false;
      }
    });

    /************************************************************
     * 解答モードエリアの横幅
     ************************************************************/

    const kaitouToolboxWidth = computed((): number => {
      let rtn = 0;
      if(isTextDrawable.value && isCanvasDrawable.value){
        rtn = 320;
      }else if(isTextDrawable.value){
        rtn = 130;
      }else if(isCanvasDrawable.value){
        rtn = 233;
      }

      if(isCanvasDrawable.value && state.tabNo == TabNoEnum.KyouzaiAnswer){
        rtn += 37;
      }

      return rtn;
    });

    /************************************************************
     * 採点モード切り替え AnserImageArea.vueからemitされる
     ************************************************************/
    
    const changeDrawMode = (drawMode: number) => {
      
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
      
      state.selectedStamp = null;
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    /************************************************************
     * 教材タブの解答・自己採点モード切り替え AnserImageArea.vueからemitされる
     ************************************************************/

    const changeCurrentMode = (currentMode: number) => {
      state.kyouzaiItem.currentMode = currentMode;
    }

    /************************************************************
     * 解答ツールボックスの表示判定
     ************************************************************/

    const isKaitouToolBoxVisible = computed((): boolean => {
      return selectedBaseSheetItem.value.currentMode == CurrentModeEnum.Answer && selectedBaseSheetField.value != null;
    });

    /************************************************************
     * 自己採点ツールボックスの表示判定
     ************************************************************/

    const isScoringToolBoxVisible = computed((): boolean => {
      return selectedBaseSheetItem.value.currentMode == CurrentModeEnum.SelfScoring && selectedBaseSheetField.value != null && !state.isScrolling;
    });

    /************************************************************
     * 保存ボタンの表示判定
     ************************************************************/

    const isSaveButtonVisible = computed((): boolean => {
      return !context.root.$store.state.is_parent && selectedBaseSheetItem.value.currentMode != CurrentModeEnum.Preview && [TabNoEnum.KyouzaiAnswer, TabNoEnum.TestAnswer].includes(state.tabNo);
    });

    /************************************************************
     * 選択肢解答
     ************************************************************/

    const changeChoceText = (choice_text: string) => {
      // 未回答の場合、size.widthが0になる⇒0で画面に表示しようとするとスクリプトエラーになるので1を設定
      const size = choice_text ? Common.getTextSize({text: choice_text, fontSize: 32, lineHeight: 0, direction: selectedBaseSheetField.value.answer_texts[0].direction, defaultText: ""}) : new Common.Size(1, 1);
      const answerText = selectedBaseSheetField.value.answer_texts[0];
      answerText.text = choice_text;
      answerText.width = size.width ? size.width : 1;
      answerText.height = size.height;
      answerText.x = (selectedBaseSheetField.value.width + (state.fieldMargin * 2) - size.width) / 2;
      answerText.y = (selectedBaseSheetField.value.height + (state.fieldMargin * 2) - size.height) / 2;
      answerText.base64_text = Common.createBase64Text(answerText, "");
    }

    const changeChoiceTextDirection = (direction: number) => {
      const answerText = selectedBaseSheetField.value.answer_texts[0];
      answerText.direction = direction;
      const size = answerText.text ? Common.getTextSize({text: answerText.text, fontSize: 32, lineHeight: 0, direction: answerText.direction, defaultText: ""}) : new Common.Size(1, 1);
      answerText.width = size.width ? size.width : 1;
      answerText.height = size.height;
      answerText.x = (selectedBaseSheetField.value.width + (state.fieldMargin * 2) - size.width) / 2;
      answerText.y = (selectedBaseSheetField.value.height + (state.fieldMargin * 2) - size.height) / 2;
      answerText.base64_text = Common.createBase64Text(answerText, "");
    }

// #endregion

// #region [スタンプの切り替え・追加・削除・編集など]

    /************************************************************
     * 選択中のスタンプ切り替え AnserImageArea.vueから呼ばれる
     ************************************************************/

    const changeSelectedStamp = (selectedStamp: any) => {
      state.selectedStamp = selectedStamp;
      if(state.selectedStamp){
        state.fontSize = selectedStamp.font_size;
        state.lineHeight = selectedStamp.line_height;
        state.textColor = selectedStamp.color;

        context.root.$nextTick(() => {
          const baseElem = document.getElementById(`${state.direction}-${selectedBaseSheetItem.value.base_sheet.sheet_type}-${selectedStamp.base_sheet_field_id}-${selectedStamp.idx}-text-stamp`);
          const moveElem = document.getElementById("text-edit-area");
          if(baseElem && moveElem){
            const clientRect = baseElem.getBoundingClientRect();
            if(clientRect.left + moveElem.clientWidth > window.innerWidth - 20){
              textEditBoxRef.value.textEditAreaLeft = window.innerWidth - moveElem.clientWidth - 20;
            }else{
              textEditBoxRef.value.textEditAreaLeft = clientRect.left;
            }
            
            if(clientRect.top - moveElem.clientHeight - 10 < 0){
              textEditBoxRef.value.textEditAreaTop = 10;
            }else{
              textEditBoxRef.value.textEditAreaTop = clientRect.top - moveElem.clientHeight - 10;
            }
          }
        });
      }
    }

    /************************************************************
     * テキストスタンプ追加 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const addTextStamp = (answerText: AnswerText) => {
      selectedBaseSheetField.value.answer_texts.push(answerText);
      state.selectedStamp = answerText;
    }

    /************************************************************
     * 画像スタンプ追加
     ************************************************************/
    const addAnswerImage = (event: any) => {
      
      state.drawMode = DrawModeEnum.None;

      // var files = context.root.$store.state.isMobile ? event.target.files : event.dataTransfer.files;
      const files = event.target.files;

      if(files.length > 1){
        alert("複数ファイルは選択できません。");
        return;
      }

      // 拡張子チェック
      const extentions = ["jpg", "jpeg", "heic", "png"];
      const file_work = files[0].name.split('.');
      const extention = file_work[file_work.length - 1].toLowerCase();
      if(!extentions.includes(extention)) {
        alert(`選択可能なファイルは[${extentions}]です。`);
        return;
      }

      if(extention == "heic"){
        heic2any({
          blob: files[0],
          toType: 'image/jpeg',
          quality: 1.0
        })
        .then((conversionResult: any) => {
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = URL.createObjectURL(conversionResult);
        })
        .catch(function(error) {
          console.error(error);
        });
      }else{
        const reader  = new FileReader();
        reader.onload = (e) => {        
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = e.target?.result as string;
        };
        reader.readAsDataURL(files[0]);
      }

      event.target.value = "";
    };

    /************************************************************
     * 画像ファイルロード後
     ************************************************************/

    const imageLoaded = (img: HTMLImageElement, extention: string) => {
      const imageType = extention == "png" ? "image/png" : "image/jpeg"
      let width = img.width;
      let height = img.height;

      let scale = 1;
      const scaleW = (selectedBaseSheetField.value.width - 20) / img.width;
      const scaleH = (selectedBaseSheetField.value.height - 20) / img.height;

      if(scaleW > scaleH){
        // scale = scaleH > 1 ? 1 : scaleH;
        scale = scaleH;
      }else{
        // scale = scaleW > 1 ? 1 : scaleW;
        scale = scaleW
      }

      width *= scale;
      height *= scale;

      // 画像をcanvasに描画した後にbase64文字列に変換
      const canvas = document.createElement("canvas") as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(img, 0, 0, width, height);
      const base64 = canvas.toDataURL(imageType, 1.0).replace(`data:${imageType};base64,`, "");

      const answerImage = new AnswerImage();
      answerImage.base_sheet_field_id = selectedBaseSheetField.value.id;
      answerImage.idx = selectedBaseSheetField.value.answer_image_idx++;
      answerImage.x = state.fieldMargin + 10;
      answerImage.y = state.fieldMargin + 10;
      answerImage.width = width * 0.5;
      answerImage.height = height * 0.5;
      answerImage.base64_image = base64;
      selectedBaseSheetField.value.answer_images.push(answerImage);
    }

    /************************************************************
     * テキストスタンプ削除 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const deleteTextStamp = (answerText: AnswerText) => {
      // 選択肢を表示するスタンプは削除しない
      if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Choice){
        return;
      }
      const idx = selectedBaseSheetField.value.answer_texts.indexOf(answerText);
      selectedBaseSheetField.value.answer_texts.splice(idx, 1);
      state.selectedStamp = null;
    }

    /************************************************************
     * 画像スタンプ削除
     ************************************************************/

    const deleteImageStamp = (imageStamp: any) => {
      const idx = selectedBaseSheetField.value.answer_images.indexOf(imageStamp);
      selectedBaseSheetField.value.answer_images.splice(idx, 1);
      state.selectedStamp = null;
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedStamp.text, fontSize: state.selectedStamp.font_size, lineHeight: state.selectedStamp.line_height, direction: state.selectedStamp.direction});
      
      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        let diffW = size.width - state.selectedStamp.width;
        state.selectedStamp.x -= diffW;
      }

      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間・カラー変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.selectedStamp.font_size = fontSize;
      state.selectedStamp.line_height = lineHeight;
      state.selectedStamp.color = textColor;
      const size = Common.getTextSize({text: state.selectedStamp.text, fontSize: fontSize, lineHeight: lineHeight, direction: state.selectedStamp.direction});

      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        let diffW = size.width - state.selectedStamp.width;
        state.selectedStamp.x -= diffW;
      }

      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);
    }

// #endregion

// #region [選択肢BOXの移動系処理]

    const choiceAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const choiceAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.choiceAreaLeft = e.clientX - state.pointerOffsetX;
        state.choiceAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const choiceareaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    const choiceAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

// #endregion

// #region [解答・自己採点ツールBOXの自動移動処理]

    const autoMoveToolbox = (baseElemId: string, toolboxId: string, leftPosName: string, topPosName: string) => {
      context.root.$nextTick(() => {
        const baseElem = document.getElementById(baseElemId);
        const toolbox = document.getElementById(toolboxId);

        if(baseElem && toolbox){
          const clientRect = baseElem.getBoundingClientRect();
          if(clientRect.left + toolbox.clientWidth > window.innerWidth - 20){
            // @ts-ignore
            state[leftPosName] = window.innerWidth - toolbox.clientWidth - 20;
          }else{
            // @ts-ignore
            state[leftPosName] = clientRect.left;
          }

          if(clientRect.top - toolbox.clientHeight - 10 < 0){
            // @ts-ignore
            state[topPosName] = 100;
          }else{
            // @ts-ignore
            state[topPosName] = clientRect.top - toolbox.clientHeight - 10;
          }
        }
      });
    }

// #endregion

// #region [解答ツールBOXの移動系処理]
    
    const kaitouToolboxPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const kaitouToolboxPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.kaitouToolboxLeft = e.clientX - state.pointerOffsetX;
        state.kaitouToolboxTop = e.clientY - state.pointerOffsetY;
      }
    }

    const kaitouToolboxPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const kaitouToolboxTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

// #endregion

// #region [自己採点ツールBOXの移動系処理]
    
    const scoringToolboxPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 12;
      state.pointerOffsetY = e.offsetY + 14;
      state.isDragging = true;
    }

    const scoringToolboxPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.scoringToolboxLeft = e.clientX - state.pointerOffsetX;
        state.scoringToolboxTop = e.clientY - state.pointerOffsetY;
      }
    }

    const scoringToolboxPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const scoringToolboxTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

// #endregion

// #region [自己採点ツールBOXの採点処理]

  /************************************************************
   * 自己採点
   ************************************************************/

  const changeCorrectState = async (correct_state: number) => {
    selectedBaseSheetField.value.correct_state = correct_state
    
    if(state.direction == DirectionEnum.Horizon){
      horizonQuestionImageAreaRef.value.$forceUpdate();
    }else{
      verticalAnswerImageAreaRef.value.$forceUpdate();
    }

    let isFieldChanged = false;

    const idx = selectedPageItem.value.scoreing_target_sheet_fields.indexOf(selectedBaseSheetField.value);
    if(selectedPageItem.value.scoreing_target_sheet_fields.length > idx + 1){
      // 同ページの次の設問へ
      selectedBaseSheetItem.value.baseSheetFieldIdx += 1;
      isFieldChanged = true;
    }else if(selectedBaseSheetItem.value.pageItems.length > selectedBaseSheetItem.value.answerPageIdx + 1){
      // 次のページの最初の設問へ
      selectedBaseSheetItem.value.answerPageIdx += 1;
      selectedBaseSheetItem.value.baseSheetFieldIdx = selectedPageItem.value.scoreing_target_sheet_fields[0].idx;
      isFieldChanged = true;
    }

    // 次の設問位置へスクロールしてツールボックスを移動
    if(isFieldChanged){

      context.root.$nextTick(async () => {
        // マークの位置へスクロール
        const rectElement = document.getElementById(`scoring-parent-${state.direction}-${Common.SheetTypeEnum.LessonTest}-${selectedBaseSheetField.value.id}`);
        const imageArea = document.getElementById(`answer-page-root-${state.direction}-${Common.SheetTypeEnum.LessonTest}`);

        const imageAreaWidth = imageArea.offsetWidth;
        const imageAreaHeight = imageArea.offsetHeight;
        const imageAreaTop = imageArea.scrollTop;
        const imageAreaBottom = imageAreaTop + imageAreaHeight;
        const imageAreaLeft = imageArea.scrollLeft;
        const imageAreaRight = imageArea.scrollLeft + imageAreaWidth;
        const rectTop = rectElement.offsetTop;
        const rectBottom = rectElement.offsetTop + rectElement.offsetHeight;
        const rectLeft = rectElement.offsetLeft;
        const rectRight = rectElement.offsetLeft + rectElement.offsetWidth;

        let fromTop = imageAreaTop;
        let toTop = imageAreaTop;
        let fromLeft = imageAreaLeft;
        let toLeft = imageAreaLeft;

        if(imageAreaTop > rectTop || imageAreaBottom < rectBottom){
          toTop = rectTop - (imageAreaHeight / 3);
        }

        if(imageAreaLeft > rectLeft || imageAreaRight < rectRight){
          toLeft = rectLeft - (imageAreaWidth / 3);
        }

        if(fromTop != toTop || fromLeft != toLeft){
          state.isScrolling = true;
          await Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, imageArea);
          state.isScrolling = false;
        }

        // スクロール後の座標をもとにツールボックスを移動
        const baseElemId = `scoring-parent-${state.direction}-${Common.SheetTypeEnum.LessonTest}-${selectedBaseSheetField.value.id}`;
        const toolboxId = "scoring-toolbox";
        autoMoveToolbox(baseElemId, toolboxId, "scoringToolboxLeft", "scoringToolboxTop");
      });
    }
  }

// #endregion

// #region [ショートカット系]

  /************************************************************
   * キー押下
   ************************************************************/

  const keyDown = (e:KeyboardEvent) => {

    // テキスト不可の場合のTショートカットは無効
    if(!isTextDrawable.value && e.key == "t"){
      return;
    }

    // 手書き不可の場合のD/Eショートカットは無効
    if(!isCanvasDrawable.value && (e.key == "d" || e.key == "e")){
      return;
    }

    state.keyCode = e.key;
  }

  /************************************************************
   * キー入力による採点
   ************************************************************/

  const keyUp = (e: KeyboardEvent) => {

    state.keyCode = "";

    // API通信中は処理しない
    if(!state.isShortcutKeyEnable){
      return;
    }

    // メモのtextareaがフォーカスされている場合は処理しない
    if(document.activeElement.nodeName.toLowerCase() == "textarea"){
      return;
    }

    if(e.key == "Backspace" && selectedBaseSheetField.value.answer_type != AnswerTypeEnum.Choice && state.selectedStamp != null){
      const idx = selectedBaseSheetField.value.answer_texts.indexOf(state.selectedStamp);
      selectedBaseSheetField.value.answer_texts.splice(idx, 1);

      if(state.selectedStamp.stamp_type == Common.StmapTypeEnum.Text){
        const idx = selectedBaseSheetField.value.answer_texts.indexOf(state.selectedStamp);
        selectedBaseSheetField.value.answer_texts.splice(idx, 1);
      }else if(state.selectedStamp.stamp_type == Common.StmapTypeEnum.Image){
        const idx = selectedBaseSheetField.value.answer_images.indexOf(state.selectedStamp);
        selectedBaseSheetField.value.answer_images.splice(idx, 1);
      }
      state.selectedStamp = null;
    }
  }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     ************************************************************/

    const changeDrawModeFromChild = (drawMode: number) => {
      state.drawMode = drawMode;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

// #endregion

// #region [保存・登録API]

    /************************************************************
     * 保存
     ************************************************************/

    const save = async () => {

      // 教材・テスト共に完了の場合は保存しない
      if(state.kyouzaiItem.currentMode == CurrentModeEnum.Preview && state.testItem.currentMode == CurrentModeEnum.Preview){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      let zip = new jsZip();

      let kyouzaiBaseSheetFields = new Array<BaseSheetField>();
      if(state.kyouzaiItem.currentMode != CurrentModeEnum.Preview){
        state.kyouzaiItem.pageItems.forEach(x => kyouzaiBaseSheetFields = kyouzaiBaseSheetFields.concat(x.base_sheet_fields));
        kyouzaiBaseSheetFields.forEach(x => {
          if(x.is_canvas_updated){
            zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
          }
          x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
            zip.file(`answer_text_${y.base_sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
          });
          x.answer_images.forEach(y => {
            zip.file(`answer_image_${y.base_sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
          });
        });
      }
      
      let testBaseSheetFields = new Array<BaseSheetField>();
      if(state.testItem.currentMode != CurrentModeEnum.Preview){
        state.testItem.pageItems.forEach(x => testBaseSheetFields = testBaseSheetFields.concat(x.base_sheet_fields));
        
        if(state.testItem.currentMode == CurrentModeEnum.Answer){
          testBaseSheetFields.forEach(x => {
            if(x.is_canvas_updated){
              zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
            }
            x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
              zip.file(`answer_text_${y.base_sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
            });
            x.answer_images.forEach(y => {
              zip.file(`answer_image_${y.base_sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
            });
          });
        }
      }

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("student_code", context.root.$store.state.student_code);
        fd.append("kyouzai_base_sheet_id", state.kyouzaiItem.base_sheet.id.toString());
        fd.append("test_base_sheet_id", state.testItem.base_sheet.id.toString());
        fd.append("kyouzai_times", state.kyouzaiItem.times.toString());
        fd.append("test_times", state.testItem.times.toString());
        fd.append("param_kyouzai_base_sheet_fields", JSON.stringify(kyouzaiBaseSheetFields.map(x => new ParamBaseSheetField(x))));
        fd.append("param_test_base_sheet_fields", JSON.stringify(testBaseSheetFields.map(x => new ParamBaseSheetField(x))));
        fd.append("kyouzai_update_flg", state.kyouzaiItem.currentMode != CurrentModeEnum.Preview ? "1" : "0");
        fd.append("test_update_flg", state.testItem.currentMode != CurrentModeEnum.Preview ? "1" : "0");
        fd.append("kyouzai_status", state.kyouzaiItem.currentMode == CurrentModeEnum.Answer ? Common.StudentSheetStatusEnum.Answering.toString() : Common.StudentSheetStatusEnum.SelfScoring.toString());
        fd.append("test_status", state.testItem.currentMode == CurrentModeEnum.Answer ? Common.StudentSheetStatusEnum.Answering.toString() : Common.StudentSheetStatusEnum.SelfScoring.toString());

        await http.post(`/api/student/lesson_class/save`, fd).then(response => {
          Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
          state.errors = [];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * テストの解答確定
     ************************************************************/

    const entryTestAnswer = async () => {

      let baseSheetFields = new Array<BaseSheetField>();
      state.testItem.pageItems.forEach(x => baseSheetFields = baseSheetFields.concat(x.base_sheet_fields));

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "テストの解答を登録します。よろしいですか？")){
        return;
      }

      if(baseSheetFields.filter(x => !x.isKaitouCompleted).length > 0){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未解答の設問がありますが、登録してよろしいですか？")){
          return;
        }
      }

      let zip = new jsZip();

      baseSheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.base_sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.base_sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("student_code", context.root.$store.state.student_code);
        fd.append("base_sheet_id", state.testItem.base_sheet.id.toString());
        fd.append("times", state.testItem.times.toString());
        fd.append("param_base_sheet_fields", JSON.stringify(baseSheetFields.map(x => new ParamBaseSheetField(x))));

        await http.post(`/api/student/lesson_class/entry_test_answer`, fd).then(async response => {
          state.testItem.currentMode = CurrentModeEnum.SelfScoring;
          state.testItem.status = Common.StudentSheetStatusEnum.SelfScoring;
          state.previewImageType = PreviewImageTypeEnum.Correct;
          state.isDispToggre = state.testItem.base_sheet.question_image_completed;
          changeSelectedBaseSheetField(null);
          await Common.customAlert(context.root.$bvModal, context.root.$store, `テストの解答登録が完了しました。模範解答を確認し、自己採点して提出してください。`);
          state.errors = [];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * テスト自己採点提出
     ************************************************************/

    const entryTestSelfScoring = async () => {

      let baseSheetFields = new Array<BaseSheetField>();
      state.testItem.pageItems.forEach(x => baseSheetFields = baseSheetFields.concat(x.base_sheet_fields));

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "テストを提出します。よろしいですか？")){
        return;
      }
      
      if(baseSheetFields.filter(x => x.kind == Common.SheetFieldKindEnum.FIELD && x.correct_state == null).length > 0){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "自己採点が未完了の設問がありますが、提出してよろしいですか？")){
          return;
        }
      }

      let zip = new jsZip();

      baseSheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.base_sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.base_sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("student_code", context.root.$store.state.student_code);
        fd.append("base_sheet_id", state.testItem.base_sheet.id.toString());
        fd.append("times", state.testItem.times.toString());
        fd.append("sheet_type", state.testItem.base_sheet.sheet_type.toString());
        fd.append("param_base_sheet_fields", JSON.stringify(baseSheetFields.map(x => new ParamBaseSheetField(x))));

        await http.post(`/api/student/lesson_class/entry`, fd).then(response => {
          state.testItem.currentMode = CurrentModeEnum.Preview;
          state.testItem.status = Common.StudentSheetStatusEnum.Scoring;
          changeSelectedBaseSheetField(null);
          Common.showToast(context.root.$bvToast, "提出処理が完了しました。");
          state.errors = [];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;

    }

    /************************************************************
     * アンケート登録
     ************************************************************/

    const entryQuestionnaireAnswer = async () => {
      
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "アンケートに回答します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/student/lesson_class/entry_questionnaire_answer`, {student_code: context.root.$store.state.student_code ,questionnaires: state.questionnaire_group.questionnaires}).then(response => {
        state.testItem.currentMode = CurrentModeEnum.Preview;
        changeSelectedBaseSheetField(null);
        Common.showToast(context.root.$bvToast, "処理が完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }
// #endregion

    const goBack = async () => {
      if(!context.root.$store.state.is_parent && await Common.customConfirm(context.root.$bvModal, context.root.$store, "講座一覧に戻ります。現在の書き込み内容を保存しますか？")){
        await save();
      }
      window.history.back();
    }

// #region [mounted, before unmount]

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/student/lesson_class?lesson_class_id=${context.root.$route.params.lesson_class_id}&student_code=${context.root.$store.state.student_code}`).then(response => {

        state.testItem = new BaseSheetItem(response.data.test_data, state.fieldMargin);
        state.kyouzaiItem = new BaseSheetItem(response.data.kyouzai_data, state.fieldMargin);
        state.lesson = response.data.lesson;
        state.lessonClass = response.data.lesson_class;
        state.fieldMargin = response.data.cut_margin;
        state.questionnaire_group = response.data.questionnaire_group;
        state.answerImageDiscriptions = response.data.test_data.answer_image_discriptions;
        state.questionImageDiscriptions = response.data.test_data.question_image_discriptions;

        state.kyouzaiItem.pageItems.forEach(pageItem => {
          pageItem.base_sheet_fields.forEach(base_sheet_field => {
            const self_scoring = response.data.kyouzai_data.self_scorings.find((x: any) => x.base_sheet_field_id == base_sheet_field.id)
            if(self_scoring){
              base_sheet_field.correct_state = self_scoring.correct_state;
            }
          });
        });

        if(state.testItem.status >= Common.StudentSheetStatusEnum.SelfScoring){
          state.previewImageType = PreviewImageTypeEnum.Correct;
          state.isDispToggre = state.testItem.base_sheet.question_image_completed;
        }else if(state.testItem.base_sheet.question_image_completed){
          state.previewImageType = PreviewImageTypeEnum.Question;
          state.isDispToggre = false;
        }
        
        // メッセージありの場合はアラート表示
        if(response.data.message){
          alert(response.data.message);
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet(true);
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);
      document.body.style.overflow = "hidden";

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.overflow = "";
    });

// #endregion

    return {
      ...toRefs(state),
      DrawModeEnum,
      StmapTypeEnum,
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonQuestionImageAreaRef,
      verticalQuestionImageAreaRef,
      kyouzaiAnswerImageAreaRef,
      kyouzaiExplanationImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalCorrectImageAreaRef,
      questionnaireModalRef,
      textEditBoxRef,
      AnswerTypeEnum,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      questionSheetPageChanged,
      explanationSheetPageChanged,
      correctImagePageChanged,
      changeSelectedBaseSheetField,
      selectedBaseSheetField,
      changeDrawMode,
      changeSelectedStamp,
      addTextStamp,
      deleteTextStamp,
      changeText,
      textFormatChanged,
      choiceAreaHeaderPointerDown,
      choiceAreaHeaderPointerMove,
      choiceAreaHeaderPointerUp,
      choiceareaTouchMove,
      kaitouToolboxPointerDown,
      kaitouToolboxPointerMove,
      kaitouToolboxPointerUp,
      kaitouToolboxTouchMove,
      scoringToolboxPointerDown,
      scoringToolboxPointerMove,
      scoringToolboxPointerUp,
      scoringToolboxTouchMove,
      keyDown,
      keyUp,
      changeDrawModeFromChild,
      rootTouchmove,
      isTextDrawable,
      isCanvasDrawable,
      isImageDrawable,
      kaitouToolboxWidth,
      isKaitouToolBoxVisible,
      isScoringToolBoxVisible,
      save,
      entryTestSelfScoring,
      isSaveButtonVisible,
      changeCurrentMode,
      changeCorrectState,
      entryTestAnswer,
      entryQuestionnaireAnswer,
      goBack,
      changeImageType,
      changeChoceText,
      changeChoiceTextDirection,
      addAnswerImage,
      deleteImageStamp,
     };
  }
})
